export default mapCustomSelect => {
    console.log('mapCustomSelect');
    const filtersButton = mapCustomSelect.querySelector('.select-button');
    const mapContainer = document.querySelector('.map-container');
    const filtersListContainerMobile = document.querySelector('.filters-list-container.mobile');
    const filtersListContainerDesktop = document.querySelector('.filters-list-container.desktop');

    function openList() {
        filtersButton.classList.add('open');
        mapCustomSelect.classList.add('show');

        if (window.innerWidth < 992) {
            mapContainer.classList.add('open');
            filtersListContainerMobile.classList.add('show');
        } else {
            filtersListContainerDesktop.classList.add('show');
        }
    }

    function closeList() {
        filtersButton.classList.remove('open');
        mapCustomSelect.classList.remove('show');

        if (window.innerWidth < 992) {
            mapContainer.classList.remove('open');
            filtersListContainerMobile.classList.remove('show');
        } else {
            filtersListContainerDesktop.classList.remove('show');
        }
    }

    filtersButton.addEventListener('click', () => {
        filtersButton.classList.contains('open') ? closeList() : openList();
    });

    document.addEventListener('click', event => {
        if (!event.target.closest('.input-container.custom-select')) closeList();
    });
};
